import React from 'react';
import styles from './Recommends.module.css';
import Button from '../button/Button';

// Import your images
import result1 from "../../images/אילנית המלצות 1.webp";
import result2 from "../../images/אילנית המלצות 2.webp";
import result3 from "../../images/אילנית המלצות 3.webp";
import result4 from "../../images/אילנית המלצות 4.webp";
import result5 from "../../images/אילנית המלצות 5.webp";
import result6 from "../../images/אילנית המלצות 6.webp";
import result7 from "../../images/אילנית המלצות 7.webp";

import result9 from "../../images/אילנית המלצות 9.webp";
import result10 from "../../images/אילנית המלצות 10.webp";
import result11 from "../../images/אילנית המלצות 11.webp";
import result12 from "../../images/אילנית המלצות 12.webp";

const Works = () => {
  const images = [
   result1,result2,result3,result4,result5,result5, result6, result7, 
    result9, result10, result11, result12
  ];

  const handleWhatsAppClick = () => {
    const phoneNumber = '972507277178';
    const message = 'היי חינת הזהב הגעתי מהדף שלכם, אשמח לשמוע עוד על..';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <>
   

   
      <div className={styles.container}>
        <div className={styles.scrollTrack}>
          {/* קבוצה ראשונה של תמונות */}
          <div className={styles.scrollContainer}>
            {images.map((img, index) => (
              <div key={`first-${index}`} className={styles.imageWrapper}>
                <img
                  src={img}
                  alt={`המלצה ${index + 1}`}
                  className={styles.image}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
          {/* קבוצה שנייה זהה של תמונות */}
          <div className={styles.scrollContainer}>
            {images.map((img, index) => (
              <div key={`second-${index}`} className={styles.imageWrapper}>
                <img
                  src={img}
                  alt={`המלצה ${index + 1}`}
                  className={styles.image}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
       <button className={styles.ctaButton} onClick={handleWhatsAppClick}>
          אילנית, אני רוצה לשריין תאריך
        </button>
    </>
  );
};

export default Works;